module.exports = __webpack_public_path__ + "static/media/QR-info-background.b37a9a09.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/dialog/QR-info-background.png
// module id = 403
// module chunks = 1